/* eslint-disable */
import gql from 'graphql-tag'

export const CREATE_ATTENDEE = gql`
  mutation createAttendee($eventId: ID!, $attendee: AttendeeInput!) {
    createAttendee(eventId: $eventId, attendee: $attendee) {
      id
    }
  }
`

export const CREATE_ATTENDEE_TICKET_ASSIGNMENT = gql`
  mutation createAttendeeTicketAssignment(
    $eventId: ID!
    $attendee: CreateAttendeeTicketAssignmentInput!
  ) {
    createAttendeeTicketAssignment(eventId: $eventId, attendee: $attendee) {
      id
    }
  }
`

export const GET_FLOOR_PLAN_OVERVIEW_SEAT_DETAILS_BY_TICKET_LOCATION = gql`
  query GetFloorPlanOverviewSeatDetailsByTicketLocation($eventId: ID!, $ticketLocation: String!) {
    getFloorPlanOverviewSeatDetailsByTicketLocation(
      eventId: $eventId
      ticketLocation: $ticketLocation
    ) {
      id
      createdAt
      ticketLocation
      fields
      purchases {
        orderId
        orderItem {
          name
          itemMeta
        }
      }
    }
  }
`
export const GET_ATTENDEE = gql`
  query getAttendee($eventId: ID!, $attendeeUUID: String!) {
    getEventCategories(id: $eventId) {
      id
      managed
      title
      from
      to
      currency
      VATPercentage
      flags
      builder {
        id
      }
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        workshops
        ticketPersonalization
      }
      location {
        venue
        city
      }
      eventUtils {
        id
        inviteFormStyles
      }
      categories {
        id
        name
        color
        zones
      }
      numberOfZones
      attendeeFields
    }
    getAttendee(attendeeUUID: $attendeeUUID) {
      id
      uuid
      fields
      status
      zones
      barcode
      qrcode
      category {
        id
        color
        name
        zones
      }
      avatar
      prints {
        user {
          firstName
          lastName
        }
        createdAt
      }
    }
  }
`

export const GET_ACCREDITATION_ORDER_DETAILS = gql`
  query getAccreditationOrderDetails($eventId: ID!, $attendeeUUID: String!) {
    getAccreditationOrderDetails(eventId: $eventId, attendeeUUID: $attendeeUUID) {
      attendee {
        id
        uuid
        fields
        status
        zones
        barcode
        qrcode
        category {
          id
          color
          name
          zones
        }
        avatar
        prints {
          id
          user {
            firstName
            lastName
          }
          createdAt
        }
      }
      event {
        id
        managed
        title
        from
        to
        currency
        VATPercentage
        flags
        builder {
          id
        }
        extraModules {
          categoriesAndZones
          mobileApp
          conferenceMobileApp
          expoMobileApp
          workshops
          ticketPersonalization
        }
        location {
          venue
          city
        }
        eventUtils {
          id
          inviteFormStyles
        }
        categories {
          id
          name
          color
          zones
        }
        numberOfZones
        attendeeFields
      }
      order {
        id
        uuid
        status
        buyer
        price
        paymentType
        createdAt
        language
        purchases {
          id
          orderId
          createdAt
          orderItem {
            id
            price
            name
            type
            currency
          }
          accreditation {
            id
            uuid
            fields
            status
            zones
            barcode
            qrcode
            avatar
            ticketLocation
            category {
              id
              color
              name
              zones
            }
            prints {
              id
              createdAt
              user {
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
`

export const GET_THEATER_SUBSCRIPTION_PASS_DETAILS = gql`
  query GetTheaterSubscriptionPassDetails($eventId: ID!, $accreditationUuid: String!) {
    getTheaterSubscriptionPassDetails(eventId: $eventId, accreditationUuid: $accreditationUuid) {
      attendee {
        id
        uuid
        fields
        status
        barcode
        qrcode
        ticketLocation
        prints {
          id
          createdAt
          user {
            firstName
            lastName
          }
        }
      }
      event {
        id
        title
        from
        to
        location {
          venue
          city
        }
        builder {
          id
        }
      }
      order {
        id
        uuid
        status
        buyer
        price
        paymentType
        createdAt
        language
        user {
          firstName
          lastName
          email
        }
      }
      subscriptionPurchase {
        id
        qrCode
        customerName
        customerEmail
        ticketLocation
        createdAt
      }
      subscription {
        name
        price
        valid_from
        valid_to
        venue {
          name
        }
      }
    }
  }
`

export const REVOKE_THEATER_SUBSCRIPTION_PERFORMANCE_ACCESS = gql`
  mutation RevokeTheaterSubscriptionPerformanceAccess($eventId: ID!, $accreditationUuid: String!) {
    revokeTheaterSubscriptionPerformanceAccess(eventId: $eventId, accreditationUuid: $accreditationUuid) {
      attendee {
        id
        status
      }
    }
  }
`

export const SEND_TICKETS_VIA_EMAIL = gql`
  mutation sendTicketsViaEmail($orderUUID: String!, $eventId: ID!, $lang: String!, $email: String) {
    sendTicketsViaEmail(orderUUID: $orderUUID, eventId: $eventId, lang: $lang, email: $email)
  }
`

export const RESEND_TICKET_OWNER_EMAIL = gql`
  mutation resendTicketOwnerEmail(
    $orderUUID: String!
    $eventId: ID!
    $purchaseId: ID!
    $lang: String!
  ) {
    resendTicketOwnerEmail(
      orderUUID: $orderUUID
      eventId: $eventId
      purchaseId: $purchaseId
      lang: $lang
    )
  }
`

export const GET_ATTENDEE_BY_UUID = gql`
  query getAttendeeByUUID($attendeeUUID: String!, $eventSlug: String!) {
    getAttendeeByUUID(attendeeUUID: $attendeeUUID, eventSlug: $eventSlug) {
      id
      fields
      status
      zones
      categoryId
      category {
        id
        name
      }
      barcode
      workshops {
        id
      }
      event {
        id
        title
        cover
        from
        applicationsOpen
        to
        slug
        attendeeFields
        translation {
          eventId
          translationsJSON
        }
        location {
          venue
          address1
          address2
          city
          postalCode
          country
          eventId
        }
        categories {
          name
          zones
          id
          eventId
        }
        workshops {
          id
          name
          to
          from
          lecturers {
            id
            fields
          }
          attendanceLimit
          attending
          unlimitedAttendance
          description
        }
        organization {
          id
          publicName
          legalName
          logo
          description
          facebookLink
          webLink
        }
        extraModules {
          categoriesAndZones
          mobileApp
          conferenceMobileApp
          expoMobileApp
          workshops
          ticketing
          floorPlan
          eventId
        }
        eventUtils {
          eventId
          inviteFormStyles
        }
      }
      category {
        id
        color
        name
        zones
      }
      avatar
    }
  }
`

export const UPDATE_ATTENDEE_BY_UUID = gql`
  mutation updateAttendeeByUUID(
    $attendeeUUID: String!
    $attendeeData: JSON!
    $selectedWorkshopsIds: [ID!]!
  ) {
    updateAttendeeByUUID(
      attendeeUUID: $attendeeUUID
      attendeeData: $attendeeData
      selectedWorkshopsIds: $selectedWorkshopsIds
    )
  }
`

export const UPDATE_ATTENDEE = gql`
  mutation updateAttendee($eventId: ID!, $attendeeUUID: String!, $attendee: AttendeeInput!) {
    updateAttendee(eventId: $eventId, attendeeUUID: $attendeeUUID, attendee: $attendee) {
      id
    }
  }
`

export const DELETE_ATTENDEE = gql`
  mutation deleteAttendee($eventId: ID!, $attendeeUUID: String!) {
    deleteAttendee(eventId: $eventId, attendeeUUID: $attendeeUUID)
  }
`

export const DELETE_ATTENDEES = gql`
  mutation deleteAttendees($attendeeIds: [ID!]!, $eventId: ID!) {
    deleteAttendees(attendeeIds: $attendeeIds, eventId: $eventId)
  }
`

export const APPROVE_ACCREDITATIONS = gql`
  mutation approveAttendees($attendeeIds: [ID!]!, $eventId: ID!) {
    approveAttendees(attendeeIds: $attendeeIds, eventId: $eventId)
  }
`

export const APPROVE_CURATED_INVITEES = gql`
  mutation ApproveCuratedInvitees($attendeeIds: [ID!]!, $eventId: ID!) {
    approveCuratedInvitees(attendeeIds: $attendeeIds, eventId: $eventId)
  }
`
export const DENY_ACCREDITATIONS = gql`
  mutation denyAttendees($attendeeIds: [ID!]!, $eventId: ID!) {
    denyAttendees(attendeeIds: $attendeeIds, eventId: $eventId)
  }
`

export const GET_FILTERING_OPTIONS = gql`
  query GetFilteringOptions($eventId: ID!) {
    getEventCategories(id: $eventId) {
      categories {
        id
        name
      }
    }
  }
`
export const GET_ATTENDEE_BY_BARCODE = gql`
  query getAttendeeByBarcode($barcode: ID!, $eventId: ID!) {
    getAttendeeByBarcode(barcode: $barcode, eventId: $eventId) {
      id
      uuid
    }
  }
`

export const GET_ATTENDEE_WORKSHOPS = gql`
  query GetAttendeeWorkshops($attendeeId: ID!) {
    getAttendeeWorkshops(attendeeId: $attendeeId)
  }
`

export const GET_ALLOWED_ATTENDEES_BY_EVENT_ID = gql`
  query GetAllowedAttendeesByEventId($eventId: ID!) {
    getAllowedAttendeesByEventId(eventId: $eventId) {
      id
      fields
    }
  }
`
